import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

export const HeaderContainer = styled.div`
  display: inline-block;
  width: 100%;
`;

export const AuthorInfo = styled.div`
  float: left;
  display: inline-flex;
`;
export const AuthorAvatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  vertical-align: middle;
  overflow: hidden;
`;
export const AuthorName = styled.span`
  opacity: 0.8;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 8px 0px 8px;
`;

export const RightContainer = styled.div`
  float: right;
  display: inline-flex;
  align-items: center;
  padding-top: 4px;
`;

export const SubmitTime = styled(({ hasIconsAfter, ...props }) => (
  <div {...props} />
))`
  line-height: 1.3;
  font-size: 12px;
  font-weight: 500;
  margin-left: 4px;
  ${({ hasIconsAfter }) => (hasIconsAfter ? 'margin-right: 8px' : '')};
  color: #8a94bd;
  display: inline-block;
`;

export const TagIcon = styled(Icon)`
  &&& {
    line-height: 2;
    margin-left: 2px;
    margin-right: 0;
    display: inline-block;
    width: 16px;
    height: 16px;
    font-size: 8px;
    opacity: ${(props) => (props.defaultChecked ? '0.3' : '0.8')};
    color: #ffffff;
    border-radius: 2px;
    background-color: #8a94bd;
    border-radius: 8px;
  }
`;
